import React, {} from "react"

export default function CloseSubscribePopup() {
   // event.stopPropagation();
   // event.preventDefault();
   this.setState({subscribe_popup_open: false});
   this.setState({subscribe_popup_initial_selected_tier: '', subscribe_popup_single_tier: false});
}
